import React from 'react';
import Dialog from 'material-ui/Dialog';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Icon from '@material-ui/core/Icon';
import Fab from '@material-ui/core/Fab';

let background = {
    color: "whitesmoke",
    backgroundColor: "#375139",
}
const ExpendatureDialog = ({ vouchers, dialogOpen, farmerProfile, onCancel }) => {
    const actions = [
        <button onClick={() =>
            onCancel()
        } className="uk-button uk-button-default " type="button">Cancel</button>
    ];
    return (
        <Dialog
            title={<h3 style={background}
                className="uk-modal-title">{farmerProfile.name + " " + farmerProfile.surname}'s
                vouchers and expenditure</h3>}
            modal={false}
            open={dialogOpen}
            onRequestClose={() => onCancel()}
            actions={actions}
            autoScrollBodyContent={true}>
            <div className="dialogcontainer">
                <div>
                    {vouchers.map((voucher, i) =>
                        <div key={i}>
                            <div className="farmercontentcol col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                    ID: {voucher.voucher.id}
                                </div>

                                <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                    state: {voucher.voucher.state}
                                </div>

                                <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                    Assigned Amount : {voucher.voucher.assignedAmount}
                                </div>

                                <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                    Balance: {voucher.voucher.assignedAmount - voucher.voucher.value}
                                </div>

                                <a href={"#" + voucher.voucher.id} data-toggle="collapse"
                                    className="collapsed col-sm-3 col-md-3 col-lg-3 col-xl-3"
                                    aria-expanded="false">
                                    <Fab style={{ backgroundColor: "green" }} size="small" color="primary"
                                        aria-label="add">
                                        <Icon>
                                            unfold_more</Icon>
                                    </Fab>
                                </a>

                            </div>

                            <div id={voucher.voucher.id} className="collapse" aria-expanded="false">
                                <Paper>
                                    <Table className="expensetable" style={{
                                        width: "100%",
                                        margin: "2% auto",
                                        border: "1px solid lightgrey",
                                        padding: "100px"
                                    }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ padding: "2%" }}
                                                    align="left">Product</TableCell>
                                                <TableCell style={{ padding: "2%" }}
                                                    align="left">Quantity</TableCell>
                                                <TableCell style={{ padding: "2%" }}
                                                    align="left"> Price</TableCell>
                                                <TableCell style={{ padding: "2%" }}
                                                    align="left"> Bought</TableCell>
                                                <TableCell style={{ padding: "2%" }}
                                                    align="left"> Delivered</TableCell>
                                            </TableRow>
                                        </TableHead>


                                        {voucher.expenditure.map((expense, i) =>
                                            <TableRow key={i}>
                                                <TableCell
                                                    align="left">{expense.product.success ? expense.product.data.name : "No Data"}</TableCell>
                                                <TableCell align="left">{expense.quantity}</TableCell>
                                                <TableCell align="left">R {expense.price}</TableCell>
                                                <TableCell
                                                    align="left">{expense.inserted_on.split(" ")[0]}</TableCell>
                                                <TableCell
                                                    align="left">{expense.dateChanged.split(" ")[0]}</TableCell>
                                            </TableRow>
                                        )}

                                    </Table>
                                </Paper>
                            </div>
                        </div>
                    )}
                </div>


                <div className="orderprice">


                </div>
            </div>
        </Dialog>
    )
}

export default ExpendatureDialog;


// WEBPACK FOOTER //
// ./src/components/ExpendatureDialog.js